import { Metric } from '../metric/metric';
import { BMEventsType } from '../types';
import type { CustomPerformanceEventFactoryConfig } from './types';

export const custom = (config: CustomPerformanceEventFactoryConfig): Metric => {
	return new Metric({ ...config, type: BMEventsType.CUSTOM });
};
